

import {
  CalendarOutlined,
  CloudDownloadOutlined,
} from "@ant-design/icons";
import { Button, Card, Divider, Empty, Flex } from "antd";
import moment from "moment";
import { handleDownloadExcel } from "../../utils";

export const TableOverview = ({ data, message, loading, startDate, endDate, t, accessible_download, accessible_view_past, RangePickerComponent, RangePickerMobileComponent }) => {
  const items = data || [];



  // 1. เตรียมข้อมูลสำหรับตาราง (Data Mapping)
  const tableData = items.map((item) => {
    const deposit = item.deposit || 0;
    const deposit_fee = item.deposit_fee || 0;
    const withdraw = item.withdraw || 0;
    const withdraw_fee = item.withdraw_fee || 0;
    const on_hold_deposit = item.on_hold_deposit || 0;
    const on_hold_deposit_fee = item.on_hold_deposit_fee || 0;


    const total_original = deposit - withdraw; // ยอดรวมที่ยังไม่หัก Fee

    const totalFee = deposit_fee + withdraw_fee;
    const netIncome = total_original - (totalFee);

    return {
      name: item.label || moment().format("YYYY-MM-DD"),
      deposit: deposit,
      deposit_fee: deposit_fee,
      on_hold_deposit: on_hold_deposit,
      on_hold_deposit_fee: on_hold_deposit_fee,
      withdraw: withdraw,
      withdraw_fee: withdraw_fee,
      total_fee: totalFee,
      net_income: netIncome,
    };
  });

  // 2. คำนวณยอดรวมท้ายตาราง (Grand Totals)
  const totals = tableData.reduce(
    (acc, curr) => ({
      deposit: acc.deposit + curr.deposit,
      deposit_fee: acc.deposit_fee + curr.deposit_fee,
      on_hold_deposit: acc.on_hold_deposit + curr.on_hold_deposit,
      on_hold_deposit_fee: acc.on_hold_deposit_fee + curr.on_hold_deposit_fee,
      withdraw: acc.withdraw + curr.withdraw,
      withdraw_fee: acc.withdraw_fee + curr.withdraw_fee,
      total_fee: acc.total_fee + curr.total_fee,
      net_income: acc.net_income + curr.net_income,
    }),
    {
      deposit: 0,
      deposit_fee: 0,
      on_hold_deposit: 0,
      on_hold_deposit_fee: 0,
      withdraw: 0,
      withdraw_fee: 0,
      total_fee: 0,
      net_income: 0,
    }
  );

  // 3. เตรียมข้อมูลสำหรับ Export Excel
  const dataForExcel = tableData.map((item) => ({
    [t("Date")]: item.name,
    [t("Deposits")]: item.deposit,
    [t("Deposits Fee")]: item.deposit_fee,
    [t("Deposit on hold")]: item.on_hold_deposit,
    [t("Deposit on hold Fee")]: item.on_hold_deposit_fee,
    [t("Withdrawals")]: item.withdraw,
    [t("Withdrawals Fee")]: item.withdraw_fee,
    [t("Total Fee")]: item.total_fee,
    [t("Net income")]: item.net_income,
  }));

  const start = startDate?.$d || null;
  const end = endDate?.$d || null;

  return (
    <>
      <Card
        title={

          <>

            {/* PC View Picker */}
            <div className="sm-hiden mb-3  mt-3">
              {accessible_view_past && RangePickerComponent}
            </div>

            {/* Mobile View Picker */}
            {accessible_view_past && (
              <Flex gap={5} className="md-hiden mb-3 mt-3" style={{ flexDirection: "row-reverse", marginRight: 5 }}>
                {RangePickerMobileComponent}
              </Flex>
            )}
          </>
        }
        extra={
          <>
            <Button
              disabled={tableData.length === 0}
              icon={<CloudDownloadOutlined />}
              className={`mb-3  mt-3 ${!accessible_download ? "d-none" : ""}`}
              size="medium"
              type="primary"
              onClick={() => accessible_download ? handleDownloadExcel(dataForExcel, message, "Daily Report") : alert(t("You are not permitted to download data."))}
            >
              Download Excel
            </Button>
          </>
        }
      >
        <br className="sm-hiden" />
        <Divider orientation="left" className="mt-0" style={{ borderBlockStartColor: "transparent", borderBlockEndColor: "transparent" }}>
          <span className="mt-3 mb-3" style={{ color: "#5a5a5a" }}>
            {start && end && !loading && <>
              <CalendarOutlined style={{ fontSize: "15px" }} />{" "}
              <span id="DateChart">
                {start && end && !loading
                  ? `${t("Date")} ${moment(start).format("YYYY-MM-DD")} - ${moment(end).format("YYYY-MM-DD")}`
                  : `${t("Overview Report")}`}
              </span>
            </>}

          </span>
        </Divider>
        <div className="table-responsive" style={{ overflowX: "auto" }}>


          {tableData.length === 0 ? (
            <div className="p-3">
              <Empty description={t('No data')} />
            </div>
          ) : (
            <table className="table table-hover table-bordered border-radius">
              <thead className="sticky">
                <tr
                  className="text-truncate"
                  style={{
                    fontSize: "12px",
                    color: "#676666",
                    background: "#fafafa",
                  }}
                >
                  <th className="text-left">{t("Date")}</th>
                  <th className="text-end">{t("Deposits")}</th>
                  <th className="text-end">{t("Deposits Fee")}</th>
                  <th className="text-end">{t("Deposit on hold")}</th>
                  <th className="text-end">{t("Txn Not found Fee")}</th>
                  <th className="text-end">{t("Withdrawals")}</th>
                  <th className="text-end">{t("Withdrawals Fee")}</th>
                  <th className="text-end">{t("Total Fee")}</th>
                  <th className="text-end">{t("Net income")}</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((item, index) => (
                  <tr key={index} style={{ fontSize: "12px", color: "#565252" }}>
                    <td className="td text-left">{item.name}</td>
                    <td className="td text-end">{Intl.NumberFormat().format(item.deposit)}</td>
                    <td className="td text-end">{Intl.NumberFormat().format(item.deposit_fee)}</td>
                    <td className="td text-end">{Intl.NumberFormat().format(item.on_hold_deposit)}</td>
                    <td className="td text-end">{Intl.NumberFormat().format(item.on_hold_deposit_fee)}</td>
                    <td className="td text-end">{Intl.NumberFormat().format(item.withdraw)}</td>
                    <td className="td text-end">{Intl.NumberFormat().format(item.withdraw_fee)}</td>
                    <td className="td text-end">{Intl.NumberFormat().format(item.total_fee)}</td>
                    <td className="td text-end">
                      <span style={{ color: item.net_income < 0 ? "#ff4d4f" : "#52c41a", fontWeight: 'bold' }}>
                        {item.net_income > 0 ? "+ " : ""}
                        {Intl.NumberFormat().format(item.net_income)}
                      </span>
                    </td>
                  </tr>
                ))}

                {/* แถวสรุปยอดรวม (Footer) */}
                <tr
                  className="fw-bold"
                  style={{
                    backgroundColor: totals.net_income >= 0 ? "#f6ffed" : "#fff1f0",
                    borderTop: "2px solid #d9d9d9"
                  }}
                >
                  <td className="td text-left">{t("Totals")}</td>
                  <td className="td text-end">{Intl.NumberFormat().format(parseFloat(totals.deposit).toFixed(2))}</td>
                  <td className="td text-end">{Intl.NumberFormat().format(parseFloat(totals.deposit_fee).toFixed(2))}</td>
                  <td className="td text-end">{Intl.NumberFormat().format(parseFloat(totals.on_hold_deposit).toFixed(2))}</td>
                  <td className="td text-end">{Intl.NumberFormat().format(parseFloat(totals.on_hold_deposit_fee).toFixed(2))}</td>
                  <td className="td text-end">{Intl.NumberFormat().format(parseFloat(totals.withdraw).toFixed(2))}</td>
                  <td className="td text-end">{Intl.NumberFormat().format(parseFloat(totals.withdraw_fee).toFixed(2))}</td>
                  <td className="td text-end">{Intl.NumberFormat().format(parseFloat(totals.total_fee).toFixed(2))}</td>
                  <td className="td text-end">
                    <span style={{ color: totals.net_income < 0 ? "#cf1322" : "#389e0d" }}>
                      {totals.net_income > 0 ? "+ " : ""}
                      {Intl.NumberFormat().format(parseFloat(totals.net_income).toFixed(2))}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </Card>
    </>
  );
};